import React, { useState, Component } from 'react';
import { Briefcase, BookOpen, User, Heart, MoreHorizontal } from 'lucide-react';
import { motion } from 'framer-motion';
type Category = 'Work' | 'Study' | 'Personal' | 'Health' | 'Others';
interface CategoryPickerProps {
  selected: Category;
  onSelect: (category: Category) => void;
}
export function CategoryPicker({
  selected,
  onSelect
}: CategoryPickerProps) {
  const defaultCategories: {
    id: Category;
    icon: ComponentType<{
      className?: string;
    }>;
    color: string;
  }[] = [{
    id: 'Work',
    icon: Briefcase,
    color: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400'
  }, {
    id: 'Study',
    icon: BookOpen,
    color: 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400'
  }, {
    id: 'Personal',
    icon: User,
    color: 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400'
  }, {
    id: 'Health',
    icon: Heart,
    color: 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400'
  }, {
    id: 'Others',
    icon: MoreHorizontal,
    color: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400'
  }];
  return <div className="space-y-3" data-id="element-167">
      <div className="grid grid-cols-2 gap-3" data-id="element-168">
        {defaultCategories.map(cat => {
        const Icon = cat.icon;
        return <motion.button key={cat.id} type="button" whileTap={{
          scale: 0.95
        }} onClick={() => onSelect(cat.id)} className={`
                p-4 rounded-2xl border-2 flex items-center gap-3 transition-all
                ${selected === cat.id ? 'border-game-purple bg-game-bg-purple dark:bg-purple-900/20 shadow-md' : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-[#252936]'}
              `} data-id="element-169">
              <div className={`p-2 rounded-xl ${cat.color}`} data-id="element-170">
                <Icon className="w-5 h-5" data-id="element-171" />
              </div>
              <span className="font-fredoka font-medium text-game-dark dark:text-white" data-id="element-172">
                {cat.id}
              </span>
            </motion.button>;
      })}
      </div>
    </div>;
}